import { render, staticRenderFns } from "./map-item-point.vue?vue&type=template&id=a134ba6e&scoped=true"
import script from "./map-item-point.vue?vue&type=script&lang=js"
export * from "./map-item-point.vue?vue&type=script&lang=js"
import style0 from "./map-item-point.vue?vue&type=style&index=0&id=a134ba6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a134ba6e",
  null
  
)

export default component.exports